import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getBillingProvider } from 'api/Admin/Practice/Providers';

export const useBillingProvider = ({ params = {}, options = {}, dependencies = [] }) => {
  const navigate = useNavigate();

  return useQuery(
    ['billing-provider', ...dependencies],
    () => getBillingProvider(navigate, params),
    {
      enabled: !!params.practiceId,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      keepPreviousData: true,
      staleTime: 5000,
      ...options
    }
  );
};
